<template>
  <div class="index">
    <!-- header -->  
    <Header></Header>
    <!-- swiper -->
    <swiper
      v-if="swiperList.length > 0"
      class="swiper"
      ref="mySwiper"
      :options="swiperOptions"
      id="swiper"
    >
      <swiper-slide v-for="(item, index) in swiperList" :key="index">
        <img :src="item.imgUrl" alt="" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- product-service -->
    <div class="product-service">
      <div class="product-category-title">丰富的产品与服务</div>
      <div class="product-category-enTitle">Rich Products and Services</div>
      <ul :class="{ serviceCategory: true, fixedNavbar: isfixTab }" id="navbar">
        <li
          :class="[
            'service-category-item',
            productServiceId === index ? 'active' : '',
          ]"
          v-for="(item, index) in productServiceList"
          :key="index"
          @click="productServiceItemClick(index)"
        >
          {{ item.title }}
        </li>
      </ul>
      <div class="service-content" ref="serviceContents">
        <div class="service-content-item" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:60px'" ref="openplatform">
          <div class="service-content-item-left">
            <img
              src="../assets/images/index/首页-楼盘库开放平台@2x.png"
              alt=""
            />
          </div>
          <div class="service-content-item-right">
            <div class="service-item-right-info">
              <div class="service-item-title">楼盘库开放平台</div>
              <ul class="service-item-intro">
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/openplatform_0.png"
                    alt=""
                  />
                  <span class="intro-character">统一框架</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/openplatform_1.png"
                    alt=""
                  />
                  <span class="intro-character">自由组合</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/openplatform_2.png"
                    alt=""
                  />
                  <span class="intro-character">灵活对接</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/openplatform_3.png"
                    alt=""
                  />
                  <span class="intro-character">操作简介</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="service-content-item" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:60px'" ref="xiaofangshu">
          <div class="service-content-item-left">
            <img src="../assets/images/index/首页-小房书@2x.png" alt="" />
          </div>
          <div class="service-content-item-right">
            <div class="service-item-right-info">
              <div class="service-item-title">小房书门店管理系统</div>
              <ul class="service-item-intro">
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/xiaofangshu_icon0.png"
                    alt=""
                  />
                  <span class="intro-character">中介门店锁定主营视野战场</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/xiaofangshu_icon1.png"
                    alt=""
                  />
                  <span class="intro-character">跟踪市场行情</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/xiaofangshu_icon2.png"
                    alt=""
                  />
                  <span class="intro-character">中介门店运营管理</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="service-content-item" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:60px'" ref="res">
          <div class="service-content-item-left">
            <img src="../assets/images/index/首页-res@2x.png" alt="" />
          </div>
          <div class="service-content-item-right">
            <div class="service-item-right-info">
              <div class="service-item-title">RES 房地产数据分析系统</div>
              <ul class="service-item-intro">
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/res_icon0.png"
                    alt=""
                  />
                  <span class="intro-character"
                    >房地产一二三级房地产案例联动</span
                  >
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/res_icon1.png"
                    alt=""
                  />
                  <span class="intro-character"
                    >时间、地理、属性三大纬度便捷查询</span
                  >
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/res_icon2.png"
                    alt=""
                  />
                  <span class="intro-character">系统稳定</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="service-content-item" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:60px'" ref="ras">
          <div class="service-content-item-left">
            <img src="../assets/images/index/首页-ras@2x.png" alt="" />
          </div>
          <div class="service-content-item-right">
            <div class="service-item-right-info">
              <div class="service-item-title">RAS 房地产价格跟踪系统</div>
              <ul class="service-item-intro">
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/ras_icon0.png"
                    alt=""
                  />
                  <span class="intro-character">房价即时查询</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/ras_icon1.png"
                    alt=""
                  />
                  <span class="intro-character">价格走势预判</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/ras_icon2.png"
                    alt=""
                  />
                  <span class="intro-character">电子估价报告</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/ras_icon3.png"
                    alt=""
                  />
                  <span class="intro-character">地址覆盖率高</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="service-content-item" :style="isfixTabCss && isfixTab ? 'padding-top:90px' : 'padding-top:60px'" ref="chengtu">
          <div class="service-content-item-left">
            <img src="../assets/images/index/首页-城图@2x.png" alt="" />
          </div>
          <div class="service-content-item-right">
            <div class="service-item-right-info">
              <div class="service-item-title">城图地图数据分析决策系统</div>
              <ul class="service-item-intro">
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/chengtu_icon0.png"
                    alt=""
                  />
                  <span class="intro-character">实时监测细微变化</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/chengtu_icon1.png"
                    alt=""
                  />
                  <span class="intro-character">颗粒化数据精细化剖析</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/chengtu_icon2.png"
                    alt=""
                  />
                  <span class="intro-character">房地产市场详细档案归档</span>
                </li>
                <li>
                  <img
                    class="icon"
                    src="../assets/images/index/chengtu_icon3.png"
                    alt=""
                  />
                  <span class="intro-character">热力图大数据分析</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- resolve-case -->
    <div class="resolve-case">
      <div class="resolve-case-title">多样化的解决方案</div>
      <div class="resolve-case-enTitle">Diversified Solutions</div>
      <div class="case-list">
        <div class="case-list-wrapper">
        <div
          class="case-list-item"
          v-for="(item, index) in resolveCaseList"
          :key="index"
        >
          <div class="case-list-item-wrapper">
            <img class="bgUrl" :src="item.bgUrl" alt="" />
            <img class="case-item-icon" :src="item.icon" alt="" />
            <div class="case-item-title">{{ item.title }}</div>
            <ul class="case-item-intro">
              <li v-for="(v, i) in item.catrgoryTitles" :key="i">
                <div class="circular">
                  <div class="light"></div>
                </div>
                <div class="text">{{ v.text }}</div>
              </li>
            </ul>
          </div>
          <div class="layer">
            <img class="case-bg" :src="item.layerBgUrl" alt="" />
            <div class="case-icon-title">
              <img :src="item.bigIcon" alt="" />
              <div class="case-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <img class="wave" src="../assets/images/index/case-bg.png" alt="" />
    </div>
    <!-- dataBase -->
    <div class="data-base">
      <div class="data-base-wrapper">
      <div class="data-base-title">海量数据</div>
      <div class="data-base-subtitle">Massive Data</div>
      <div class="data-num-list">
        <div
          class="data-num-item"
          v-for="(item, index) in dataCategoryList"
          :key="index">
          <div
            class="num"
            v-if="(index === 0 || index === 1 || index === 2) && scrollTop>=3300" >
            <animate-number
              from="1"
              :to="item.num"
              duration="1000"
              easing="easeOutQuad"
              :formatter="formatter"></animate-number>+
          </div>
          <div class="num" v-if="index === 3&& scrollTop>=3300">
            <animate-number
              from="1"
              :to="item.num"
              duration="1000"
              easing="easeOutQuad"
              :formatter="formatter"></animate-number>%+
          </div>
          <div class="data-category">{{ item.categoryName }}</div>
        </div>
      </div>
      </div>
    </div>
    <!-- all-win -->
    <div class="all-win">
      <div class="all-win-title">携手共赢</div>
      <div class="all-win-subtitle">Work Together for A Win-win Situation</div>
      <div class="win-category-list">
        <div
          :class="[
            'win-category-item',
            winCategoryId === index ? 'active' : '',
          ]"
          v-for="(item, index) in winCategoryList"
          :key="index"
          @click="winCategoryItemClick(index)"
        >
          {{ item.text }}
        </div>
      </div>
      <div class="win-category-detail-list" v-if="realEstateDevelopmentFlag">
        <div
          class="win-category-detail-item"
          v-for="(item, index) in realEstateDevelopment"
          :key="index"
        >
          <img :src="item.imgUrl" alt="" />
          <div class="category-name">{{ item.categoryName }}</div>
        </div>
      </div>
      <div class="win-category-detail-list" v-if="realEstateAgentFlag">
        <div
          class="win-category-detail-item"
          v-for="(item, index) in realEstateAgent"
          :key="index"
        >
          <img :src="item.imgUrl" alt="" />
          <div class="category-name">{{ item.categoryName }}</div>
        </div>
      </div>
      <div class="win-category-detail-list" v-if="realEstateAppraisalFlag">
        <div
          class="win-category-detail-item"
          v-for="(item, index) in realEstateAppraisal"
          :key="index"
        >
          <img :src="item.imgUrl" alt="" />
          <div class="category-name">{{ item.categoryName }}</div>
        </div>
      </div>
      <div
        class="win-category-detail-list finance-list"
        v-if="realEstateFinanceFlag"
      >
        <div
          class="win-category-detail-item finance-item"
          v-for="(item, index) in realEstateFinance"
          :key="index"
        >
          <img :src="item.imgUrl" alt="" />
          <div class="category-name">{{ item.categoryName }}</div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
    <!-- login -->
    <Login></Login>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import Swiper2, { Navigation, Pagination, Autoplay } from "swiper";

Swiper2.use([Navigation, Pagination, Autoplay]);

export default {
  name: "Index",
  components: {
    Swiper,
    SwiperSlide,
    Header,
    Footer,
    Login
  },
  computed: {},
  data() {
    return {
      text: "",
      username: "",
      swiperOptions: {
        // swiper属性
        autoplay: {
          stopOnLastSlide: true,
          delay: 2000
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: true,
        speed: 1000
      },
      swiperList: [
        {
          imgUrl: require("../assets/images/index/banner1.png")
        },
        {
          imgUrl: require("../assets/images/index/banner2.png")
        }
      ],
      productServiceList: [
        {
          title: "楼盘库开放平台"
        },
        {
          title: "小房书门店管理系统"
        },
        {
          title: "RES 房地产数据分析系统"
        },
        {
          title: "RAS 房地产价格跟踪系统"
        },
        {
          title: "城图地图数据分析决策系统"
        }
      ],
      isfixTab: false, // 是否置顶
      isfixTabCss: false, //控制导航栏样式
      productServiceId: 0,
      resolveCaseList: [
        {
          icon: require("../assets/images/index/fangchan_icon1.png"),
          bigIcon: require("../assets/images/index/fangchan_icon0.png"),
          bgUrl: require("../assets/images/index/fangchan_bg2.png"),
          layerBgUrl: require("../assets/images/index/fangchan_bg.png"),
          title: "房产中介经纪机构",
          catrgoryTitles: [
            {
              text: "宏观布局、战略决策"
            },
            {
              text: "企业中台运营与管理"
            },
            {
              text: "微观业务支持"
            },
            {
              text: "房源管理系统的楼盘库基础数据支持"
            }
          ]
        },
        {
          icon: require("../assets/images/index/kaifashang_icon1.png"),
          bigIcon: require("../assets/images/index/kaifashang_icon0.png"),
          bgUrl: require("../assets/images/index/kaifashang_bg2.png"),
          layerBgUrl: require("../assets/images/index/kaifashang_bg.png"),
          title: "开发商机构",
          catrgoryTitles: [
            {
              text:
                "从取证、认筹、认购、新房网签、二手房网签等各截点即时监测项目"
            },
            {
              text: "支持土地可行性研究"
            },
            {
              text: "支持产品、课题深入研究"
            },
            {
              text: "支持营销策略制定与调整"
            }
          ]
        },
        {
          icon: require("../assets/images/index/pinggu_icon1.png"),
          bigIcon: require("../assets/images/index/pinggu_icon0.png"),
          bgUrl: require("../assets/images/index/pinggu_bg2.png"),
          layerBgUrl: require("../assets/images/index/pinggu_bg.png"),
          title: "房产评估",
          catrgoryTitles: [
            {
              text: "提供土地、新房、二手房高质量案例"
            },
            {
              text: "支持市场研究报告服务地产金融"
            },
            {
              text:
                "支持电子估价系统搭建（可选合作：楼盘框架基价、价格算法、系统部署）"
            },
            {
              text: "房源管理系统的楼盘库基础数据支持"
            }
          ]
        },
        {
          icon: require("../assets/images/index/zhuangxiu_icon1.png"),
          bigIcon: require("../assets/images/index/zhuangxiu_icon0.png"),
          bgUrl: require("../assets/images/index/zhuangxiu_bg2.png"),
          layerBgUrl: require("../assets/images/index/zhuangxiu_bg.png"),
          title: "装修行业",
          catrgoryTitles: [
            {
              text: "支持地产基础数据，提升服务专业度、服务效率"
            },
            {
              text: "房地产市场助力装修业务营销拓展"
            }
          ]
        }
      ],
      dataCategoryList: [
        {
          num: 17000,
          categoryName: "楼盘"
        },
        {
          num: 700000,
          categoryName: "幢号"
        },
        {
          num: 10000000,
          categoryName: "室号"
        },
        {
          num: 95,
          categoryName: "准确度"
        }
      ],
      winCategoryId: 0,
      winCategoryList: [
        {
          text: "房地产开发"
        },
        {
          text: "房地产经纪"
        },
        {
          text: "房地产评估"
        },
        {
          text: "房地产金融"
        }
      ],
      realEstateDevelopment: [
        {
          imgUrl: require("../assets/images/index/万科@2x.png"),
          categoryName: "万科"
        },
        {
          imgUrl: require("../assets/images/index/龙湖@2x.png"),
          categoryName: "龙湖"
        },
        {
          imgUrl: require("../assets/images/index/华润@2x.png"),
          categoryName: "华润"
        },
        {
          imgUrl: require("../assets/images/index/融创@2x.png"),
          categoryName: "融创"
        },
        {
          imgUrl: require("../assets/images/index/仁恒@2x.png"),
          categoryName: "仁恒"
        }
      ],
      realEstateAgent: [
        {
          imgUrl: require("../assets/images/index/链家@2x.png"),
          categoryName: "链家"
        },
        {
          imgUrl: require("../assets/images/index/中原@2x.png"),
          categoryName: "中原地产"
        },
        {
          imgUrl: require("../assets/images/index/太平洋@2x.png"),
          categoryName: "太平洋房屋"
        },
        {
          imgUrl: require("../assets/images/index/我爱我家@2x.png"),
          categoryName: "我爱我家"
        },
        {
          imgUrl: require("../assets/images/index/美凯龙@2x.png"),
          categoryName: "美凯龙爱家"
        }
      ],
      realEstateAppraisal: [
        {
          imgUrl: require("../assets/images/index/城市估价@2x.png"),
          categoryName: "城市估价"
        },
        {
          imgUrl: require("../assets/images/index/八达国瑞@2x.png"),
          categoryName: "八达国瑞"
        },
        {
          imgUrl: require("../assets/images/index/百盛估价@2x.png"),
          categoryName: "百盛估价"
        },
        {
          imgUrl: require("../assets/images/index/世联估价@2x.png"),
          categoryName: "世联估价"
        },
        {
          imgUrl: require("../assets/images/index/东洲估价@2x.png"),
          categoryName: "东洲估价"
        }
      ],
      realEstateFinance: [
        {
          imgUrl: require("../assets/images/index/建设银行@2x.png"),
          categoryName: "中国建设银行"
        },
        {
          imgUrl: require("../assets/images/index/招商银行@2x.png"),
          categoryName: "招商银行"
        },
        {
          imgUrl: require("../assets/images/index/工商银行@2x.png"),
          categoryName: "中国工商银行"
        },
        {
          imgUrl: require("../assets/images/index/华杰资信  @2x.png"),
          categoryName: "华杰资信"
        }
      ],
      realEstateDevelopmentFlag: true,
      realEstateAgentFlag: false,
      realEstateAppraisalFlag: false,
      realEstateFinanceFlag: false,
      footList: [
        {
          title: "新手入门",
          subtitle: "Beginner'sGuide",
          categoryList: [
            {
              text: "关于我们"
            },
            {
              text: "产品介绍"
            },
            {
              text: "开发文档"
            }
          ]
        },
        {
          title: "商务合作",
          subtitle: "Business Cooperation",
          categoryList: [
            {
              text: "商务合作"
            }
          ]
        },
        {
          title: "相关协议",
          subtitle: "Related Agreements",
          categoryList: [
            {
              text: "用户隐私和服务条款"
            },
            {
              text: "免责声明"
            }
          ]
        }
      ],
      scrollTop: 100
    };
  },
  methods: {
    smoothFun(node) {
      this.$refs[node].scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    },
    productServiceItemClick(index) {
      // navbar点击高亮显示
      this.productServiceId = index;
      // 锚点跳转
      if (index === 0) {
        this.smoothFun("openplatform");
      } else if (index === 1) {
        this.smoothFun("xiaofangshu");
      } else if (index === 2) {
        this.smoothFun("res");
      } else if (index === 3) {
        this.smoothFun("ras");
      } else if (index === 4) {
        this.smoothFun("chengtu");
      }
      this.isfixTabCss = true;
    },
    winCategoryItemClick(index) {
      // 携手共赢切换显示
      this.winCategoryId = index;
      if (index === 0) {
        this.realEstateDevelopmentFlag = true;
        this.realEstateAgentFlag = false;
        this.realEstateAppraisalFlag = false;
        this.realEstateFinanceFlag = false;
      } else if (index === 1) {
        this.realEstateDevelopmentFlag = false;
        this.realEstateAgentFlag = true;
        this.realEstateAppraisalFlag = false;
        this.realEstateFinanceFlag = false;
      } else if (index === 2) {
        this.realEstateDevelopmentFlag = false;
        this.realEstateAgentFlag = false;
        this.realEstateAppraisalFlag = true;
        this.realEstateFinanceFlag = false;
      } else if (index === 3) {
        this.realEstateDevelopmentFlag = false;
        this.realEstateAgentFlag = false;
        this.realEstateAppraisalFlag = false;
        this.realEstateFinanceFlag = true;
      }
    },
    formatter: function(num) {
      return num.toFixed(0);
    },
    handleTabFix() {
      // 监测滚动的高度
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
      var offsetTop = document.querySelector("#navbar").offsetTop;
      scrollTop > offsetTop ? (this.isfixTab = true) : (this.isfixTab = false);

      // 1：先拿到当前的节点下的 距离顶部的距离
      let serviceContents = this.$refs.serviceContents;

      let productServiceOffsetTop = document.querySelector(".product-service")
        .offsetTop;
      if (scrollTop < productServiceOffsetTop) {
        this.isfixTab = false;
      } else {
        this.isfixTab = true;
      }

      let resolveCaseOffsetTop = document.querySelector(".resolve-case")
        .offsetTop;
      if (scrollTop > resolveCaseOffsetTop) this.isfixTab = false;

      // 获取每项距离顶部的高度
      let floorList, floor_0, floor_1, floor_2, floor_3, floor_4;
      if (serviceContents) {
        floorList = serviceContents.querySelectorAll(".service-content-item");
        floor_0 = floorList[0].offsetTop - 70;
        floor_1 = floorList[1].offsetTop - 70;
        floor_2 = floorList[2].offsetTop - 70;
        floor_3 = floorList[3].offsetTop - 70;
        floor_4 = floorList[4].offsetTop - 70;
      }
      if (scrollTop) {
        // 判断高度区间
        if (floor_0 <= scrollTop && scrollTop < floor_1) {
          this.productServiceId = 0;
        } else if (floor_1 <= scrollTop && scrollTop < floor_2) {
          this.productServiceId = 1;
        } else if (floor_2 <= scrollTop && scrollTop < floor_3) {
          this.productServiceId = 2;
        } else if (floor_3 <= scrollTop && scrollTop < floor_4) {
          this.productServiceId = 3;
        } else if (scrollTop >= floor_4) {
          this.productServiceId = 4;
        }
      }
    },
    goTopClick() {
      // 一键回到顶部
      let timer = setInterval(() => {
        let ispeed = Math.floor(-this.scrollTop / 10);
        document.documentElement.scrollTop = document.body.scrollTop =
          this.scrollTop + ispeed;
        if (this.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    }
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleTabFix, true);
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleTabFix, true);
    next();
  }
};
</script>

<style lang="less">
.swiper {
  width: 100%;
  // height: 560px;
  position: relative;

  img {
    width: 100%;
    // height: 560px;
    display: block;
  }

  .swiper-pagination-bullet {
    margin: 0 !important;
    width: 32px;
    height: 2px;
    background: #fff;
    // opacity: 0.25;
    border-radius: 0;
    margin-left: 8px !important;
  }

  .swiper-pagination-bullet-active {
    background: rgba(255, 255, 255, 0.25);
    position: relative;

    &::after {
      content: "";
      width: 32px;
      height: 2px;
      background: #3880f4;
      opacity: 1 !important;
      border-radius: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      animation: loading 2s linear;
    }
  }

  @keyframes loading {
    from {
      width: 0px;
    }
    to {
      width: 32px;
    }
  }
}

.product-service {
  width: 100%;
  background: #fff;

  .product-category-title {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #272727;
    text-align: center;
    line-height: 40px;
    margin-top: 70px;
  }

  .product-category-enTitle {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #999999;
    text-align: center;
    line-height: 22px;
    letter-spacing: 2px;
  }

  .serviceCategory {
    width: 1140px;
    height: 63px;
    margin: 0 auto;
    border-bottom: 1px solid #f5f5f5;
    display: flex;
    justify-content: space-around;

    &.fixedNavbar {
      width: 1140px;
      height: 63px;
      margin: 0 auto;
      background: #fff;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      justify-content: space-around;
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    .service-category-item {
      line-height: 64px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #272727;
      position: relative;
      cursor: pointer;

      &:hover {
        color: #3880f4;
      }
    }

    .active {
      color: #3880f4;

      &::after {
        content: "";
        width: 100px;
        height: 4px;
        background: #3880f4;
        border-radius: 2px 2px 0px 0px;
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .service-content {
    width: 1140px;
    margin: 0 auto;
    padding-bottom: 40px;

    .service-content-item {
      width: 100%;
      overflow: hidden;
      margin-top: 49px;
      padding-top: 60px;

      .service-content-item-left {
        width: 50%;
        float: left;
      }

      .service-content-item-right {
        width: 50%;
        float: right;

        .service-item-right-info {
          width: 305px;
          height: 370px;

          .service-item-title {
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #272727;
            line-height: 33px;
            margin-top: 24px;
          }

          .service-item-intro {
            margin-top: 49px;

            li {
              width: 100%;
              height: 24px;
              margin-top: 50px;

              .icon {
                width: 24px;
                height: 24px;
                float: left;
              }

              .intro-character {
                line-height: 24px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666;
                float: left;
                margin-left: 24px;
              }
            }
          }
        }
      }
      &:nth-child(2n-1) .service-content-item-left {
        width: 60%;
        float: left;
      }

      &:nth-child(2n-1) .service-content-item-right {
        width: 40%;
        float: right;
      }

      &:nth-child(2n) .service-content-item-left {
        width: 60%;
        float: right;
      }

      &:nth-child(2n) .service-content-item-right {
        width: 40%;
        float: left;
      }

      &:nth-child(4) .service-content-item-left {
        width: 65%;
        float: right;
      }

      &:nth-child(4) .service-content-item-right {
        width: 35%;
        float: left;
      }

      &:nth-child(1) .service-content-item-left img {
        width: 602px;
        height: 421px;
        display: block;
      }

      &:nth-child(2) .service-content-item-left img {
        width: 635px;
        height: 438px;
        display: block;
      }

      &:nth-child(3) .service-content-item-left img {
        width: 600px;
        height: 433px;
        display: block;
      }

      &:nth-child(4) .service-content-item-left img {
        width: 740px;
        height: 421px;
        display: block;
      }

      &:nth-child(5) .service-content-item-left img {
        width: 625px;
        height: 424px;
        display: block;
      }

      &:nth-child(2n-1) .service-content-item-right .service-item-right-info {
        margin-left: 35px;
      }

      &:nth-child(2n) .service-content-item-right .service-item-right-info {
        float: right;
        // margin-right: 100px;
      }
    }
  }
}

.resolve-case {
  width: 100%;
  height: 804px;
  overflow: hidden;
  background: #fafbfc;
  position: relative;

  .resolve-case-title {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    text-align: center;
    color: #272727;
    line-height: 40px;
    margin-top: 56px;
  }

  .resolve-case-enTitle {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    color: #999;
    line-height: 22px;
    letter-spacing: 2px;
  }

  .case-list {
    width: 1140px;
    height: 530px;
    margin: 0 auto;
    margin-top: 56px;
    position: relative;

    .case-list-wrapper {
      width: 1140px;
      height: 530px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
    }

    .case-list-item {
      width: 285px;
      height: 530px;
      float: left;
      overflow: hidden;
      position: relative;
      // box-shadow: 0px 4px 12px 0px rgba(56, 128, 244, 0.12);
      position: relative;
      cursor: pointer;

      .bgUrl {
        width: 64px;
        height: 180px;
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        z-index: 9;
      }

      &:nth-child(2) .bgUrl {
        width: 130px;
        height: 190px;
        display: block;
      }

      &:nth-child(3) .bgUrl {
        width: 136px;
        height: 182px;
        display: block;
      }

      &:nth-child(4) .bgUrl {
        width: 98px;
        height: 162px;
        display: block;
      }

      .case-list-item-wrapper {
        width: 285px;
        height: 530px;
        position: absolute;
        top: 0;
        left: 0;
        // z-index: 99;
        background: linear-gradient(180deg, #ffffff 0%, #eef5ff 100%);

        .case-item-icon {
          width: 32px;
          height: 32px;
          display: block;
          margin: 0 auto;
          margin-top: 80px;
        }

        .case-item-title {
          text-align: center;
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #272727;
          line-height: 25px;
          margin-top: 24px;
        }

        .case-item-intro {
          width: 90%;
          margin: 0 auto;

          li {
            width: 90%;
            margin: 0 auto;
            margin-top: 32px;
            overflow: hidden;

            .circular {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background: #c7dbfc;
              position: relative;
              float: left;
              margin-top: 6px;

              .light {
                width: 4px;
                height: 4px;
                background: #3880f4;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }

            .text {
              width: 195px;
              float: left;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #272727;
              line-height: 20px;
              margin-left: 15px;
            }
          }
        }
      }
      .layer {
        width: 285px;
        height: 530px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;

        .case-bg {
          width: 285px;
          height: 530px;
          display: block;
          position: absolute;
          top: 0;
          left: 0;
        }

        .case-icon-title {
          width: 285px;
          height: 530px;
          position: absolute;
          top: 0;
          left: 0;

          img {
            width: 55px;
            height: 55px;
            display: block;
            margin: 0 auto;
            margin-top: 202px;
          }

          .case-title {
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ffffff;
            line-height: 40px;
            margin-top: 35px;
            text-align: center;
          }
        }
      }
      &:hover {
        box-shadow: 0px 4px 12px 0px rgba(56, 128, 244, 0.12);
        border-radius: 4px 0px 0px 4px;

        .layer {
          opacity: 0;
          transition: all 0.1s ease;
        }
      }
    }
  }
  .wave {
    width: 100%;
    height: 159px;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

.data-base {
  width: 100%;
  height: 330px;
  background: url("../assets/images/index/dataBaseBg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;

  .data-base-wrapper {
    width: 1140px;
    height: 300px;
    margin: 0 auto;
  }

  .data-base-title {
    margin-top: 56px;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
  }

  .data-base-subtitle {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    line-height: 22px;
    letter-spacing: 2px;
  }

  .data-num-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 48px;

    .data-num-item {
      .num {
        height: 45px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 45px;
        position: relative;

        &::after {
          content: "";
          width: 32px;
          height: 3px;
          background: #fff;
          position: absolute;
          bottom: -8px;
          left: 6px;
        }
      }

      .data-category {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-top: 16px;
        margin-left: 6px;
      }
    }
  }
}

.all-win {
  width: 100%;
  height: 600px;
  overflow: hidden;

  .all-win-title {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    text-align: center;
    color: #272727;
    line-height: 40px;
    margin-top: 56px;
  }

  .all-win-subtitle {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    color: #999;
    line-height: 22px;
    letter-spacing: 2px;
  }

  .win-category-list {
    width: 737px;
    height: 44px;
    margin: 0 auto;
    margin-top: 32px;

    .win-category-item {
      width: 158px;
      height: 44px;
      border-radius: 2px;
      border: 1px solid #e3e3e3;
      text-align: center;
      line-height: 44px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      float: left;
      margin-right: 32px;
      cursor: pointer;

      &:last-child {
        margin-right: 0px;
      }

      &.active {
        width: 160px;
        height: 46px;
        background: #3880f4;
        box-shadow: 0px 2px 10px 0px rgba(56, 128, 244, 0.5);
        border-radius: 2px;
        color: #fff;
        border: none;
      }

      &:hover {
        width: 160px;
        height: 46px;
        background: #3880f4;
        box-shadow: 0px 2px 10px 0px rgba(56, 128, 244, 0.5);
        border-radius: 2px;
        color: #fff;
        border: none;
      }
    }
  }

  .win-category-detail-list {
    width: 1140px;
    height: 250px;
    margin: 0 auto;
    margin-top: 56px;

    .win-category-detail-item {
      width: 228px;
      height: 250px;
      float: left;
      overflow: hidden;

      img {
        width: 164px;
        height: 164px;
        display: block;
        margin: 0 auto;
        margin-top: 16px;
      }

      .category-name {
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        text-align: center;
        color: #272727;
        line-height: 22px;
        margin-top: 8px;
      }

      &:hover {
        background: #fff;
        box-shadow: 0px 4px 12px 0px rgba(56, 128, 244, 0.12);
      }
    }
  }
  .finance-list {
    width: 912px;
    height: 250px;
    margin: 0 auto;
    margin-top: 56px;
  }
}
</style>

